module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI3MTMuODk4IiBoZWlnaHQ9IjMiIHZpZXdCb3g9IjAgMCA3MTMuODk4IDMiPjxkZWZzPjxzdHlsZT4uYXtmaWxsOm5vbmU7c3Ryb2tlOiNmZjc2ODk7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLXdpZHRoOjNweDtzdHJva2UtZGFzaGFycmF5OjQgNzt9PC9zdHlsZT48L2RlZnM+PGxpbmUgY2xhc3M9ImEiIHgyPSI3MTAuODk4IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxLjUgMS41KSIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/recruit_2021/recruit_movie_pink_line.svg
// module id = dcgp
// module chunks = 0